export function getTurnstileKey() {
  return process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || '';
}
